export const CARELEVEL_RESET_MODULE_ANSWERS = 'CARELEVEL_RESET_MODULE_ANSWERS';
export const CARELEVEL_UPDATE_ANSWER = 'CARELEVEL_PUSH';
export const CARELEVEL_UPDATE_INPUT_VALUES = 'CARELEVEL_UPDATE_INPUT_VALUES';
export const CARELEVEL_UPDATE_OVERVIEW_INPUT_VALUE = 'CARELEVEL_UPDATE_OVERVIEW_INPUT_VALUE';
export const CARELEVEL_UPDATE_OVERVIEW_RADIO_BUTTONS = 'CARELEVEL_UPDATE_OVERVIEW_RADIO_BUTTONS';
export const CARELEVEL_REQUEST = 'CARELEVEL_REQUEST';
export const CARELEVEL_CLEAR_WIZARD = 'CARELEVEL_CLEAR_WIZARD';
export const CARELEVEL_SET_TRACKING_UUID = 'CARELEVEL_SET_TRACKING_UUID';
